import { makeStyles } from "$components/mui-styles";
import { useFormatPenceFactory } from "$routes/_lib/use-format-pence";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  table: {
    fontSize: 14,
    width: "100%",
  },
  lineItemRoot: {
    marginBottom: theme.spacing(1),
  },
  lineItemCell: {
    paddingRight: theme.spacing(1),
  },
  lineItemPriceCell: {
    textAlign: "right",
  },
}));

const LineItems = ({ lineItems }) => {
  const classes = useStyles();
  const formatPence = useFormatPenceFactory();

  return (
    <table className={classes.table}>
      <tbody>
        {lineItems.map((lineItem) => (
          <tr key={lineItem.id} className={classes.lineItemRoot}>
            <td className={classes.lineItemCell}>
              {lineItem.priceListItem.name}
            </td>
            <td className={classes.lineItemCell}>{`x${lineItem.quantity}`}</td>
            <td className={classes.lineItemPriceCell}>
              {formatPence(lineItem.cost)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

LineItems.propTypes = {
  lineItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      quantity: PropTypes.number,
      priceListItem: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  ).isRequired,
};

export default LineItems;
